// Module
var code = "<div ng-class=\"$ctrl.titleClass\">\n    {{ $ctrl.title }}\n    <div class=\"landing-page-underline\"></div>\n</div>\n";
// Exports
module.exports = code;